<template>
	<view class="container">
    <scroll-view scroll-y class="scroll_v">
      
      <view class="top_view">
        <view class="top_bgview"></view>
        <view class="top_content_v">
          <view class="top_content_v_left">
            <view class="top_content_v_left_top">
               <img class="login_image" src="@/assets/images/login_icon.png" />
              <view class="login_text_v">
                <text class="login_top_text">免押宝</text>
                <view class="login_bottom_text">让租赁更轻松！</view>
              </view>
            </view>
            <view class="top_content_v_left_bottom">
              <view @click="androidDownEvent" class="download_btn1">
                <text>Android下载</text>
                <img src="@/assets/images/android_icon.png" />
              </view>
              <view @click="iosDownEvent" class="download_btn2">
                <text>iPhone下载</text>
                <img src="@/assets/images/iphone_icon.png" />
              </view>
            </view>
          </view>
          <view class="top_content_v_right">
             <img class="phoneimage" src="@/assets/images/phone_icon.png" />
          </view>
        </view>
      </view>
      
      <view class="content_v">
        <text class="content_v_text">产品功能介绍</text>
        <text class="content_v_text1">免押宝APP是一款专注于解决数码设备租赁押金问题的创新工具。通过深度对接支付宝芝麻信用系统，为商户与客户搭建安全、高效的信用认证桥梁。用户只需简单扫码操作，即可实现芝麻分实时查询与免押资格判定，让租赁流程更便捷，信任更简单。</text>
          <view class="product_list">
            <view class="product_list_item">
              <img src="@/assets/images/product_image1.png" />
              <text>扫码免押认证</text>
            </view>
            <view class="product_list_item">
              <img src="@/assets/images/product_image2.png" />
              <text>实时信用评估</text>
            </view>
            <view class="product_list_item">
              <img src="@/assets/images/product_image3.png" />
              <text>免押资格确认</text>
            </view>
            <view class="product_list_item">
              <img src="@/assets/images/product_image4.png" />
              <text>安全加密保障</text>
            </view>
          </view>
      </view>
      
      <view class="content_one_v">
        <text class="content_one_v_title">产品优势</text>
        <text class="content_one_v_title_item">信任升级：以支付宝芝麻分为信用背书，科学评估用户履约能力。</text>
        <text class="content_one_v_title_item">操作极简：扫码即认证，无需复杂注册或资料提交。</text>
        <text class="content_one_v_title_item">效率提升：免除押金收退流程，租赁成交时间缩短80%。</text>
        <text class="content_one_v_title_item">广泛适用：覆盖全品类数码设备租赁场景，商户客户双向赋能。</text>
      </view>
      
      <view class="content_two_v">
        <view class="content_two_v_one">
          <text class="bottom_text1">重庆从宝科技有限公司</text>
          <text class="bottom_text2">渝ICP备2023007760号-12A</text>
        </view>
        <view class="content_two_v_two">
          <text @click="pushPrivacy" class="bottom_text3">隐私政策</text>
          <text class="bottom_text4">用户协议</text>
          <text class="bottom_text5">联系我们：15367551041</text>
        </view>
      </view>
    </scroll-view>
	</view>
</template>

<script setup>
import '@/assets/fonts/CustomFont.css';
import { onMounted } from 'vue';

onMounted(() => {
  console.log(`the component is now mounted.`)
})


function androidDownEvent () { 
const link = document.createElement('a');
    link.href = 'https://oss.congbaoba.cn/apk/cbmy.apk';
    link.download = 'mianyabo.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function iosDownEvent() {
    const link = document.createElement('a');
    link.href = 'https://apps.apple.com/app/id6749663651';
    link.download = 'mianyabo.download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
</script>

<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   // text-align: center;
//   // color: #2c3e50;
// }

@media screen and (min-width: 640px){
    .container {
      width: 100vw;
      height: 100vh;
      .scroll_v{
        width: 100vw;
        height: 100vh;
        
        .top_view{
          width: 100%;
          height: 900px;
          display: flex;
          position: relative;
          .top_bgview{
            background: #1A79FF;
            display: flex;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 1;
          }
          .top_content_v{
            display: flex;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 2;
            flex-direction: row;
            .top_content_v_left{
              display: flex;
              flex-direction: column;
              .top_content_v_left_top{
                display: flex;
                flex-direction: row;
                .login_image{
                  margin-top: 131px;
                  margin-left: 330px;
                  width: 200px;
                  height: 200px;
                }
                .login_text_v{
                  margin-top: 161px;
                  display: flex;
                  flex-direction: column;
                  .login_top_text{
                    font-size: 60px;
                    color: #FFFFFF;
                    font-family: AlimamaShuHeiTiBold;
                  }
                  .login_bottom_text{
                    font-size: 40px;
                    color: #FFFFFF;
                    margin-top: 19px;
                  }
                }
              }
              .top_content_v_left_bottom{
                margin-top: 239px;
                margin-left: 360px;
                display: flex;
                .download_btn1{
                  background: #FFFFFF;
                  box-shadow: 10px 3px 6px 1px rgba(103,93,70,0.16);
                  border-radius: 4px;
                  border: 2px solid #E6E6E6;
                  width: 220px;
                  height: 80px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text{
                    font-size: 20px;
                    color: #000000;
                  }
                  img{
                    width: 36px;
                    height: 42px;
                    margin-left: 20px;
                  }
                }
                .download_btn2{
                  background: #FFFFFF;
                  box-shadow: 10px 3px 6px 1px rgba(103,93,70,0.16);
                  border-radius: 4px;
                  border: 2px solid #E6E6E6;
                  width: 220px;
                  height: 80px;
                  margin-left: 30px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text{
                    font-size: 20px;
                    color: #000000;
                  }
                  img{
                    width: 36px;
                    height: 42px;
                    margin-left: 20px;
                  }
                }
              }
            }
            .top_content_v_right{
              display: flex;
              // margin-right: 360px;
              margin-left: 130px;
              .phoneimage{
                margin-top: 144px;
                width: 624px;
                height: 751px;
              }
            }
          }
        }

        .content_v{
          display: flex;
          background: #FFFFFF;
          width: 100%;
          height: 855px;
          flex-direction: column;

          .content_v_text{
            margin-left: 360px;
            margin-top: 120px;
            font-size: 36px;
            color: #000000;
          }

          .content_v_text1{
            margin: 30px 360px 0 360px;
            font-size: 32px;
            color: #000000;
          }

          .product_list{
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 100px;
            .product_list_item{
              margin-left: 53px;
              width: 260px;
              height: 300px;
              background: #FFFFFF;
              box-shadow: 6px 6px 0px 1px rgba(76,81,94,0.16);
              border-radius: 5px;
              border: 2px solid #E6E6E6;
              display: flex;
              justify-content: center;
              // align-content: center;
              align-items: center;
              flex-direction: column;
              img{
                width: 120px;
                height: 120px;
              }
              text{
                margin-top: 31px;
                font-size: 30px;
                color: #292C33;
              }
            }
          }
        }
        
        .content_one_v{
          display: flex;
          background: #F2F8FF;
          height: 545px;
          flex-direction: column;
          .content_one_v_title{
            margin-left: 360px;
            margin-top: 90px;
            font-size: 36px;
            color: #000000;
            flex-direction: column;
            margin-bottom: 10px;
          }
          .content_one_v_title_item{
              font-size: 32px;
              color: #000000;
              margin-left: 360px;
              margin-top: 10px;
              display: flex;
              
            }
        }
        
        .content_two_v{
          display: flex;
          background: #09152A;
          height: 126px;
          
          flex-direction: column;
          .content_two_v_one{
            margin-left: 360px;
            margin-top: 29px;
            display: flex;
            flex-direction:row;
            .bottom_text1{
              color: #FFFFFF;
            }
            .bottom_text2{
              margin-left: 60px;
              color: #FFFFFF;
            }
          }
          .content_two_v_two{
            display: flex;
            flex-direction:row;
            margin-left: 360px;
            margin-top: 20px;
            .bottom_text3{
              color: #FFFFFF;
            }
            .bottom_text4{
              color: #FFFFFF;
              margin-left: 32px;
            }
            .bottom_text5{
              color: #FFFFFF;
              margin-left: 60px;
            }
          }
        }
      }
    }
  }

	/* 手机端 */
	@media screen and (max-width: 750px) {

  }

</style>
